/** Normalised ASR job statuses for LNG-02 UI */

export const PROCESSING_STATUSES = [
  'processing',
  'recording',
  'pending',
  'starting_transcription',
  'summarizing',
  'chunking',
  'chunked',
  'pending_chunking',
  'uploading',
  'in_progress',
  'pending_priority',
  'queued',
];

export const normalizeJobStatus = (raw) => {
  const value = String(raw || 'pending').toLowerCase().trim();

  if (['completed', 'complete', 'done', 'success'].includes(value)) {
    return 'complete';
  }
  if (['failed', 'error', 'cancelled', 'canceled'].includes(value)) {
    return 'failed';
  }
  if (['queued', 'pending_priority'].includes(value)) {
    return 'queued';
  }
  if (PROCESSING_STATUSES.includes(value)) {
    return 'processing';
  }

  return 'processing';
};

export const isProcessingStatus = (status) => {
  const normalised = normalizeJobStatus(status);
  return normalised === 'queued' || normalised === 'processing';
};

export const getStatusLabel = (status) => {
  const labels = {
    queued: 'Queued',
    processing: 'Processing',
    complete: 'Complete',
    failed: 'Failed',
  };
  return labels[normalizeJobStatus(status)] || 'Processing';
};

export const getStatusBadgeClass = (status) => {
  const classes = {
    queued: 'status-queued',
    processing: 'status-processing',
    complete: 'status-complete',
    failed: 'status-failed',
  };
  return classes[normalizeJobStatus(status)] || 'status-processing';
};

export const getStatusIcon = (status) => {
  const icons = {
    queued: '◷',
    processing: '⏳',
    complete: '✓',
    failed: '✕',
  };
  return icons[normalizeJobStatus(status)] || '';
};

/** Placeholder ETA copy for long-running jobs (LNG-02-AC2) */
export const getEtaPlaceholder = (status, queuedAt, etaSeconds) => {
  const normalised = normalizeJobStatus(status);
  if (normalised === 'complete' || normalised === 'failed') {
    return null;
  }

  const seconds = Number(etaSeconds);
  if (Number.isFinite(seconds) && seconds >= 0) {
    if (seconds < 60) {
      return 'Estimated under a minute remaining';
    }
    const minutes = Math.max(1, Math.round(seconds / 60));
    return `Estimated ~${minutes} min remaining`;
  }

  if (queuedAt) {
    const elapsedMinutes = Math.floor((Date.now() - new Date(queuedAt).getTime()) / 60000);
    if (elapsedMinutes > 30) {
      return 'Taking longer than usual — still processing';
    }
    if (elapsedMinutes > 10) {
      return 'Estimated ~5–15 min remaining';
    }
  }

  return normalised === 'queued'
    ? 'Waiting in queue — typically starts within a few minutes'
    : 'Estimated ~3–10 min remaining';
};
